let mimeType;

const audioMediaConstraints = { 
    audio: true, 
    video: false
}; 


let pElement = null; // Global reference to the paragraph element for appending transcripts

// Helper function to update the transcript in the DOM
function updateTranscriptInDOM(text, isNewTurn=false) {
    if (isNewTurn || !pElement) {
        var transcriptionResult = document.getElementById('transcriptionResult');
        // clear the previous content
        transcriptionResult.innerHTML = '';
        var div = document.createElement('div');
        transcriptionResult.classList.add('client-message', 'py-4');
        pElement = document.createElement('p');
        pElement.innerHTML = "<span class=\"text-indigo-500\"><strong>Your response: </strong></span>";
        div.append(pElement);
        transcriptionResult.append(div);
    }
    pElement.innerHTML += text + ' '; // Append the new text to the existing <p> element
    pElement.classList.add('text-indigo-500');
}


export const startwarmupRecording = () => {
    
    ASR_transcript = '';

    if (MediaRecorder.isTypeSupported('audio/webm; codecs=opus')) {
        var options = {mimeType: 'audio/webm; codecs=opus'};
    } else  if (MediaRecorder.isTypeSupported('audio/webm')) {
        var options = {mimeType: 'audio/webm'};
    } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
        var options = {mimeType: 'audio/mp4'};
    } else {
        console.error("no suitable mimetype found for this device");
    }


    let deepgram_model = "general";
    navigator.mediaDevices.getUserMedia(audioMediaConstraints).then(stream => {
            mediaRecorder = new MediaRecorder(stream, options);

            deepgram_socket = new WebSocket(`wss://${window.location.host}/ws/deepgram/`)

            chunks.length = 0; // to store the audio chunks

            deepgram_socket.onopen = () => {
                console.log({ event: 'onopen' })
                mediaRecorder.addEventListener('dataavailable', async (event) => {
                    if (event.data.size > 0 && deepgram_socket.readyState == 1) {
                        deepgram_socket.send(event.data)
                        chunks.push(event.data);
                    }
                })
                mediaRecorder.start(1000)
                updateTranscriptInDOM('', true);  // Add a new paragraph for the new turn
            }

            deepgram_socket.onmessage = (message) => {
                const received = JSON.parse(message.data)
                const transcript = received.channel.alternatives[0].transcript
                if (transcript && received.is_final) {
                    ASR_transcript += transcript + ' '; 
                    updateTranscriptInDOM(transcript); 
                }
            }
            
            deepgram_socket.onerror = (error) => {
                console.log({ event: 'onerror', error })
            }
        }).catch(error => {
            console.log(error)
            document.getElementById('transcriptionResult').textContent = "Oops. Error accessing microphone. Please ensure that you have given permission to access your microphone and reload this window.";
            document.getElementById('transcriptionResult').classList.add('text-red-500');
        });
    
          
  };
  
  const closeWebSocketConnection = (deepgram_socket) => {
    return new Promise((resolve, reject) => {
        // Check if the socket connection is still open
        if (deepgram_socket && deepgram_socket.readyState === WebSocket.OPEN) {
            // Send the CloseStream command to Deepgram
            deepgram_socket.send(JSON.stringify({ type: "CloseStream" }));

            // Listen for the server's response before closing
            deepgram_socket.onmessage = (message) => {
                const finalserverTranscript = JSON.parse(message.data).channel.alternatives[0].transcript;
                // Now close the socket after receiving final message
                deepgram_socket.close();
                resolve(finalserverTranscript); // Resolve the promise with the final transcript  
            };
        
            // Handle case where WebSocket closes before sending final message
            deepgram_socket.onclose = () => {
                console.log({ event: 'WebSocket closed' });
                resolve(null); // Resolve the promise when the WebSocket closes if no final message is received
            };
        } else {
            resolve(null); // Resolve immediately if the socket is not open
        }
    });
  };

  // Stop audio recording
  export const stopwarmupRecording = () => {
      return new Promise((resolve, reject) => {

        if (mediaRecorder && mediaRecorder.state === 'recording') {
            mediaRecorder.addEventListener('stop', async () => {
                recordedAudioBlob = new Blob(chunks);  
                const finalserverTranscript = await closeWebSocketConnection(deepgram_socket); // Wait for the final message  
                ASR_transcript += finalserverTranscript
                updateTranscriptInDOM(finalserverTranscript); 

                resolve(recordedAudioBlob); // Resolve the promise when recording is stopped and blob is set

            });

            
            
            if (chunks.length==0) {
                // Apply a timeout to allow for the last transcription to complete
                setTimeout(() => {
                    mediaRecorder.stop();
                    console.log('Setting timeout. Recording stopped with chunks-', chunks.length);
                    // closeWebSocketConnection();
                }, 2000); 
                } else {
                    mediaRecorder.stop();
                    // closeWebSocketConnection(deepgram_socket);
                }
            }
        else {
            reject(new Error('No active recording to stop'));
        }
    });
  };